import React, { useState } from 'react';
import colorData from '../data/colors.json';
import { FaTrash } from "react-icons/fa";
import './ColorSelector.css';

const ColorSelector = ({ setCustomization, customization, setColorDisabled }) => {
    const [selectedColors, setSelectedColors] = useState(customization.colors || []); // Estado para los colores seleccionados
    const [searchTerm, setSearchTerm] = useState(''); // Estado para la búsqueda de colores
    const [isDisabled, setIsDisabled] = useState(false); // Estado para deshabilitar la selección de colores
    const [noApplyClicked, setNoApplyClicked] = useState(false); // Estado para saber si se hizo clic en "No aplica"

    // Filtrar los colores por nombre
    const filteredColors = colorData.colors.filter((color) =>
        color.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Manejar la selección de un color
    const handleColorSelect = (color) => {
        if (!selectedColors.some(selectedColor => selectedColor.hex === color.hex) && !isDisabled) {
            const newColors = [...selectedColors, { name: color.name, hex: color.hex }];
            setSelectedColors(newColors);
            setCustomization({ ...customization, colors: newColors });
        }
        setSearchTerm(''); // Limpiar la búsqueda después de seleccionar
    };

    // Eliminar un color de la lista de seleccionados
    const handleColorRemove = (colorToRemove) => {
        const newColors = selectedColors.filter(color => color.hex !== colorToRemove.hex);
        setSelectedColors(newColors);
        setCustomization({ ...customization, colors: newColors });
    };

    // Manejar el botón de "No aplica"
    const handleNoApply = () => {
        setSelectedColors([]);
        setCustomization({ ...customization, noApplyClicked: true });
        setIsDisabled(true);
        setNoApplyClicked(true);
        setColorDisabled(true); // Marcar que el color ha sido deshabilitado
    };

    // Habilitar el selector de colores nuevamente cuando el usuario elimine todos los colores
   const handleColorRemoveAll = () => {
        setSelectedColors([]);
        setCustomization({ ...customization, colors: [] });
        setIsDisabled(false);
        setNoApplyClicked(false);
        setColorDisabled(false); // Rehabilitar el selector de colores
    };

    return (
        <div className="color-selector">
            <div className="color-search">
                <label>Selecciona un color:</label>
                <input
                    type="text"
                    placeholder="Buscar colores"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    disabled={isDisabled} // Deshabilitar el campo de búsqueda si está bloqueado
                />
                {/* Muestra los colores filtrados */}
                {searchTerm && filteredColors.length > 0 && (
                    <div className="color-list">
                        {filteredColors.map((color) => (
                            <div
                                key={color.name}
                                onClick={() => handleColorSelect(color)}
                                className="color-item"
                                style={{ backgroundColor: color.hex }}
                            >
                                <div className="color-box" style={{ backgroundColor: color.hex }}></div>
                            </div>
                        ))}
                    </div>
                )}
                {/* Mensaje si no hay coincidencias */}
                {searchTerm && filteredColors.length === 0 && (
                    <div className="no-results">No se encontraron colores que coincidan.</div>
                )}
                {/* Botón "No aplica" */}
                <button onClick={handleNoApply} className="no-apply-btn" disabled={isDisabled}>
                    No aplica
                </button>
            </div>

            {/* Mostrar los colores seleccionados solo si hay colores o si se hizo clic en "No aplica" */}
            {(selectedColors.length > 0 || noApplyClicked) && (
                <div className="selected-colors-list">
                    <h3>Colores seleccionados:</h3>
                    {selectedColors.length > 0 ? (
                        <div className="selected-colors">
                            {selectedColors.map((color, index) => (
                                <div key={index} className="selected-color-item">
                                    <div className="color-box" style={{ backgroundColor: color.hex }}></div>
                                    <span>{color.name}</span> {/* Mostrar el nombre del color */}
                                    <button onClick={() => handleColorRemove(color)}><FaTrash /></button>
                                </div>
                            ))}
                        </div>
                    ) : (
                        // Mostrar "No aplica" si no hay colores seleccionados y se hizo clic en el botón "No aplica"
                        noApplyClicked && (
                            <div className="selected-color-item">
                                <p>No aplica</p>
                                {/* Botón "Eliminar" para eliminar el mensaje "No aplica" */}
                                <button onClick={handleColorRemoveAll}><FaTrash /></button>
                            </div>
                        )
                    )}
                </div>
            )}
        </div>
    );
};

export default ColorSelector;
